const ROOT_SELECTOR = '[data-h3p-contenu-structure]';
const PANEL_SELECTOR =
    ':scope > .h3p-contenu-structure__panels > .wp-block-h3p-partie-contenu';

const COMPACT_MAX_ITEMS = 3;

function slugify(value) {
    return (
        value
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '') || 'partie'
    );
}

function initStructuredContent(root, rootIndex) {
    if (root.dataset.h3pInitialized === 'true') {
        return;
    }

    const nav = root.querySelector(
        '.h3p-contenu-structure__nav'
    );

    const prevButton = root.querySelector(
        '.h3p-contenu-structure__arrow--prev'
    );

    const nextButton = root.querySelector(
        '.h3p-contenu-structure__arrow--next'
    );

    const panels = Array.from(
        root.querySelectorAll(PANEL_SELECTOR)
    );

    if (!nav || panels.length === 0) {
        return;
    }

    let activeIndex = 0;

    const tabs = panels.map((panel, index) => {
        const label =
            panel.dataset.label || `Partie ${index + 1}`;

        const baseId =
            `h3p-contenu-${rootIndex}-${slugify(label)}-${index}`;

        const tabId = `${baseId}-tab`;
        const panelId = `${baseId}-panel`;

        const tab = document.createElement('button');

        tab.type = 'button';
        tab.className = 'h3p-contenu-structure__tab';
        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.setAttribute(
            'aria-selected',
            index === 0 ? 'true' : 'false'
        );
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.textContent = label;

        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.hidden = index !== 0;

        nav.appendChild(tab);

        return tab;
    });

    const isCompact = tabs.length <= COMPACT_MAX_ITEMS;

    root.classList.toggle('is-compact', isCompact);
    root.classList.toggle('is-full', !isCompact);

    function updateScrollableState() {
        const isScrollable =
            !isCompact
            && nav.scrollWidth > nav.clientWidth + 1;

        root.classList.toggle(
            'is-scrollable',
            isScrollable
        );
    }

    function updateArrows() {
        if (prevButton) {
            prevButton.hidden = isCompact;
            prevButton.disabled =
                isCompact || activeIndex === 0;
            prevButton.tabIndex = isCompact ? -1 : 0;
            prevButton.setAttribute(
                'aria-hidden',
                isCompact ? 'true' : 'false'
            );
        }

        if (nextButton) {
            nextButton.hidden = isCompact;
            nextButton.disabled =
                isCompact
                || activeIndex === tabs.length - 1;
            nextButton.tabIndex = isCompact ? -1 : 0;
            nextButton.setAttribute(
                'aria-hidden',
                isCompact ? 'true' : 'false'
            );
        }
    }

    function activate(index, moveFocus = false) {
        if (index < 0 || index >= tabs.length) {
            return;
        }

        activeIndex = index;

        tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;

            tab.setAttribute(
                'aria-selected',
                isActive ? 'true' : 'false'
            );

            tab.tabIndex = isActive ? 0 : -1;

            panels[tabIndex].hidden = !isActive;
        });

        tabs[activeIndex].scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
        });

        if (moveFocus) {
            tabs[activeIndex].focus({
                preventScroll: true,
            });
        }

        updateArrows();
    }

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            activate(index);
        });

        tab.addEventListener('keydown', (event) => {
            let nextIndex = null;

            if (event.key === 'ArrowRight') {
                nextIndex = Math.min(
                    activeIndex + 1,
                    tabs.length - 1
                );
            } else if (event.key === 'ArrowLeft') {
                nextIndex = Math.max(
                    activeIndex - 1,
                    0
                );
            } else if (event.key === 'Home') {
                nextIndex = 0;
            } else if (event.key === 'End') {
                nextIndex = tabs.length - 1;
            }

            if (nextIndex !== null) {
                event.preventDefault();
                activate(nextIndex, true);
            }
        });
    });

    if (!isCompact) {
        prevButton?.addEventListener('click', () => {
            activate(activeIndex - 1);
        });

        nextButton?.addEventListener('click', () => {
            activate(activeIndex + 1);
        });
    }

    if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
            updateScrollableState();
        });

        resizeObserver.observe(nav);
    } else {
        window.addEventListener(
            'resize',
            updateScrollableState
        );
    }

    root.dataset.h3pInitialized = 'true';

    updateScrollableState();
    updateArrows();
    activate(activeIndex);
}

function initAllStructuredContent() {
    document
        .querySelectorAll(ROOT_SELECTOR)
        .forEach((root, rootIndex) => {
            initStructuredContent(root, rootIndex);
        });
}

if (document.readyState === 'loading') {
    document.addEventListener(
        'DOMContentLoaded',
        initAllStructuredContent
    );
} else {
    initAllStructuredContent();
}